import $ from "jquery";
import {
  PaymentCalculatorFactory,
  Formatter,
} from "@dealersites/dealersite-js-core";
import { IncentivesService } from "@dealersites/oem/services/incentives.js";

import "./bottom-bar";
import "./configure";
import "./summary";

const showroomPage = $("#showroom-container-FLP");

$(() => {

  // Targeted Incentives Toggle Select Styles
$('.js-targeted-incentive').on("change", function() {
  $(this).closest('.js-targeted-incentive-label').toggleClass("selected");
});

  $(".IncentiveValue .js-payment").each(function () {
    const $payment = $(this);

    const calcInputs = {
      price: $payment.data("price"),
      down: $payment.data("down"),
      term: $payment.data("term"),
      rate: $payment.data("rate"),
      tradein: $payment.data("tradein"),
      tax: 0,
    };

    const frequency = $payment.data("frequency") ?? 'biweekly';

    const calcType = $payment.data("calculator");
    if (calcType === "lease") {
      calcInputs.residual = $payment.data("residual");
    }

    const calculator = PaymentCalculatorFactory.createCalculator(
      calcType,
      calcInputs
    );
    if (calculator) {
      calculator.calculate();
      $payment.text(Formatter.price(calculator.payments[frequency], 0));
    }
  });
});

if (showroomPage.length !== 0) {

  const dsp = (global.dsp = global.dsp || {});
  if (!dsp.incentives) {
    dsp.incentives = IncentivesService;
  }


 // Back to Models Links
  const showroomPageURL = window.location.href;
  let urlArray = showroomPageURL.split('/');
  urlArray.pop()
  const urlEndpoint = urlArray.pop();
  localStorage.setItem('myShowroom', urlEndpoint);
  
}
